document.addEventListener("DOMContentLoaded", function() {

  /* Cart drawer quick add cards - swap the button text between "Sold out" and
     "Add to cart" when a size is tapped. (09.10.26) This used to re-attach a new
     click listener to every size label once a second, forever, so listeners piled
     up the longer the page was open. One shared listener does the same job. */
  document.addEventListener('click', function (event) {
    const label = event.target.closest && event.target.closest('.card_product_add .swatch-content label');
    if (!label) return;
    const isSoldOut = label.classList.contains('soldout');
    const isAddToCart = label.classList.contains('addToCart');
    if (!isSoldOut && !isAddToCart) return;
    const parentCard = label.closest('.card_product_add');
    if (!parentCard) return;
    const button = parentCard.querySelector('.product__submit__item button');
    if (!button) return;
    const span = button.querySelector('span.btn__text');
    if (!span) return;
    if (isSoldOut && span.textContent.trim() === 'Add to cart') {
      span.textContent = 'Sold out';
    } else if (isAddToCart && span.textContent.trim() === 'Sold out') {
      span.textContent = 'Add to cart';
    }
  });

const container = document.querySelector(".cart-swiperContainer_in");
const step = 310;
const duration = 310; // in milliseconds

// Manual smooth scroll function using requestAnimationFrame
function smoothScrollBy(container, distance, duration) {
    const start = container.scrollLeft;
    const startTime = performance.now();

    function scroll(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // clamp between 0 and 1

        // easeInOutQuad easing
        const ease = progress < 0.5
            ? 2 * progress * progress
            : -1 + (4 - 2 * progress) * progress;

        container.scrollLeft = start + distance * ease;

        if (elapsed < duration) {
            requestAnimationFrame(scroll);
        } else {
            container.scrollLeft = start + distance; // ensure exact end
        }
    }

    requestAnimationFrame(scroll);
}

// Previous Button
document.querySelector(".cart--button-prev").addEventListener("click", function (event) {
    event.preventDefault();
    smoothScrollBy(container, -step, duration);
});

// Next Button
document.querySelector(".cart--button-next").addEventListener("click", function (event) {
    event.preventDefault();
    smoothScrollBy(container, step, duration);
});


    
  const cartReviewSwiper = document.querySelector('.reviewSlider_slider');
    if(cartReviewSwiper) {
      var mySwiperReview = new Swiper(".reviewSlider_slider", {
        loop: true,
        slidesPerView: 1,
        spaceBetween:10,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed:500,
        paginationClickable: true,
        // autoHeight: true,
        navigation: {
          nextEl: ".cart-review-next",
          prevEl: ".cart-review-prev",
        },
      });
    }

  const inputs = document.querySelectorAll('.cart_fotterNote_row input');
  const textarea = document.querySelector('.cart__widget__content .cart__widget__content__inner textarea#note');

  function updateTextarea() {
    let combinedText = '';

    inputs.forEach(function(input) {
      let val = input.value.trim();
      if (val !== '') {
        combinedText += val + ' '; // Add space or change separator if needed
      }
    });

    textarea.value = combinedText.trim();
  }

  inputs.forEach(function(input) {
    input.addEventListener('input', updateTextarea);
  });

  setInterval(function () {
    const progress = document.querySelector('.free-shipping__progress-bar');
    const imgWrapper = document.querySelector('.freeShipping_img');
    const freeShipping_progress = document.querySelector('.freeShipping_progress_line');
  
    const value = parseFloat(progress.value);
    // Only write when the value changes (09.10.26) - this runs 100 times a second,
    // and rewriting the same styles every time kept the page busy on phones
    const percent = `${value}%`;
    if (imgWrapper.style.left !== percent) imgWrapper.style.left = percent;
    if (freeShipping_progress.style.width !== percent) freeShipping_progress.style.width = percent;
  }, 10);

  // ==============================

  setInterval(function () {
    const cartTitles = Array.from(document.querySelectorAll(".cart__item .cart__item__content-inner .cart__item__title a"))
        .map(el => el.textContent.trim());
    const collectionProducts = document.querySelectorAll(".cart-swiper-container .collection_product");

    collectionProducts.forEach(product => {
        const productName = product.getAttribute("data-name")?.trim();

        if (cartTitles.includes(productName)) {
            product.style.display = "none";
        } else {
            if (product.style.display === "none") {
                product.style.display = "";
            }
        }
    });
  }, 1000);

  let cartPopupShown = false;
  
  setInterval(function () {
      var cartStatus = document.querySelector('.header__cart__status');
      var cartCount = cartStatus ? cartStatus.getAttribute('data-cart-count') : "0";
      var countSpan = document.querySelector('.cart-drawer__head h3 span.getCount');
      if (countSpan) {
          countSpan.textContent = `${cartCount} Items`;
      }
  
      var footerNote = document.querySelector('.cart_fotterNote');
      var footerSlide = document.querySelector('.cart-drawer__collection');
      var footerItem = document.querySelector('.cart-drawer__items');
      var cartPopup = document.querySelector('.cart_drawer_popup');
      var cartReview = document.querySelector('.empty_reviewSlider');
  
      if (footerNote || footerSlide) {
          if (cartCount === "0") {
              footerNote.classList.add('empty-cart-note');
              footerSlide.classList.add('empty-cart-note');
              footerItem.classList.add('empty-cart-note');
              cartReview.style.display = 'block';
              if (cartPopup) cartPopup.style.display = 'none';
              cartPopupShown = false;
          } else {
              footerNote.classList.remove('empty-cart-note');
              footerSlide.classList.remove('empty-cart-note');
              footerItem.classList.remove('empty-cart-note');
              cartReview.style.display = 'none';
             
              if (!cartPopupShown && cartPopup) {
                  cartPopup.style.display = 'block';
                  cartPopupShown = true;
              }
          }
      }
  }, 100);

  let selectOptionvalue = document.querySelectorAll('.productVariantSlider');
  if(selectOptionvalue) {
    selectOptionvalue.forEach(selectBox => {
      selectBox.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const selectedValue = selectedOption.value;
        const parent = this.closest('.collection_product');
        const input = parent.querySelector('.card__content .card_product_add form.product-form input.producyVariantInpur');
        if (input) {
          input.value = selectedValue;
          console.log('Updated input value:', input.value);
        } else {
          console.warn('Target input not found');
        }
      });
    });
  }

  
// variant update

  document.querySelectorAll('.swatch-container .radio__button label').forEach(label => {
    label.addEventListener('click', function () {
      const selectedSize = this.querySelector('span').innerText.trim();
      const form = this.closest('form.product-form[data-product-form]');
      if (!form) return;
  
      const variantOption = form.querySelector('.productVariant_option');
      if (!variantOption) return;
  
      const matchedP = [...variantOption.querySelectorAll('p')].find(p =>
        p.getAttribute('data-name') === selectedSize
      );
      if (!matchedP) return;
  
      const variantId = matchedP.getAttribute('data-id');
      const input = form.querySelector('input.producyVariantInpur');
      if (input) {
        input.value = variantId;
      }
      const allLabels = form.querySelectorAll('.swatch-container .radio__button label');
      allLabels.forEach(lbl => lbl.classList.remove('active'));
      this.classList.add('active');
    });
  });


  function updateSoldOutStatus() {
    document.querySelectorAll('.swatch-container .radio__button label').forEach(label => {
      const span = label.querySelector('span');
      if (!span) return;
      const sizeText = span.innerText.trim();
      const form = label.closest('form.product-form[data-product-form]');
      if (!form) return;
      const variantOption = form.querySelector('.productVariant_option');
      if (!variantOption) return;
      const matchedP = [...variantOption.querySelectorAll('p')].find(p =>
        p.getAttribute('data-name') === sizeText
      );
      if (matchedP) {
        const stockQty = parseInt(matchedP.innerText.trim(), 10);
        // Only change classes when the state actually changes (09.10.26). Re-adding
        // the same classes every 2 seconds on hundreds of labels set off all the
        // page's change watchers each time, which made taps feel laggy on phones.
        const soldOut = isNaN(stockQty) || stockQty <= 0;
        if (label.classList.contains('soldout') !== soldOut) label.classList.toggle('soldout', soldOut);
        if (label.classList.contains('addToCart') === soldOut) label.classList.toggle('addToCart', !soldOut);
      }
    });
  }
  
  // Run on page load
  document.addEventListener('DOMContentLoaded', () => {
    updateSoldOutStatus();
  });
  
  setInterval(updateSoldOutStatus, 2000);

  document.querySelectorAll('.cart_popup_close').forEach(function(close) {
    close.addEventListener('click', function() {
      document.querySelector('.cart_drawer_popup').style.display = 'none';
    });
  });
  document.querySelectorAll('.navlink--cart--icon').forEach(function(open) {
    open.addEventListener('click', function() {
      document.querySelector('.cart_drawer_popup').style.display = 'block';
    });
  });
});